var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.$store.getters['answer/status2variant'](_vm.model.status)}},[_vm._v("\n        "+_vm._s(_vm.trans.labels[
        'form_answers.status.' + _vm.model.status
        ])+"\n    ")]),_vm._v(" "),([ 'paid', 'canceling' ].indexOf(_vm.model.status) >= 0)?_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v("\n        要対応\n    ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }